import { useMutation } from "@tanstack/react-query";

import { useJobActions } from "@react/domains/jobs";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useTablesActions() {
  const { api } = useAuth();

  const { updateJob } = useJobActions();

  const syncAllTables = useMutation({
    mutationFn: api.admin.syncAllTables,
    onSuccess: data => {
      for (const job of data.jobs) {
        updateJob(job);
      }
    },
  });

  const syncTable = useMutation({
    mutationFn: api.admin.syncTable,
    onSuccess: data => {
      updateJob(data.job);
    },
  });

  return { syncAllTables, syncTable };
}
